import Layout from '../../components/feature/Layout';
import AboutHero from './components/AboutHero';
import CompanyTimeline from './components/CompanyTimeline';
import MissionVision from './components/MissionVision';
import TeamMembers from './components/TeamMembers';

export default function AboutPage() {
  return (
    <Layout>
      <AboutHero />
      <MissionVision />
      <CompanyTimeline />
      <TeamMembers />
    </Layout>
  );
}
